module.exports = __webpack_public_path__ + "static/media/future_bg.c631f8a8.png";